/** Shared event_id helper for browser ↔ server CAPI deduplication. */
export const newEventId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `ev_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
};
